/* eslint-disable */
<template>
  <div class="edit-booking">
    <Navigation indexProps="2"/>
    <ProfileReadMoreModal ref="profileReadMoreModal"/>
    <div class="top-panel">
      <Header/>
      <div v-if="showContent" class="header-title-section">
        <div class="header-title">
          <h1>Edit Booking {{ booking.BookingID }} for <u>
            <router-link :to="{ name: 'manage-case', query: { id: booking.CaseID } }">Case ID:
              {{ booking.CaseID }}
            </router-link>
          </u></h1>
        </div>
        <div class="header-sub-title">{{ subTitle }}</div>
      </div>
      <div v-else class="header-title-section"><h5>Booking does not exist</h5></div>
    </div>
    <div class="panel">
      <CaseMenu :indexProps="isEdit ? '0' : '1'"/>
      <div class="content" v-if="showContent">
        <div class="top-detail">
          <div class="row m-0">
            <div class="col-4 p-0 center-title">
              <div class="row center-title m-0 display-in-row">
                <div class="col-2 p-0" v-if="booking.BookingDateTime">
                  <div class="border-image">
                    <div class="border-image-number">
                      {{ formatDate(booking.BookingDateTime, 'DD', 'YYYY-MM-DD HH:mm:ss.ssssss') }}
                    </div>
                    <div class="border-image-text">
                      {{ formatDate(booking.BookingDateTime, 'MMM, YYYY hh:mm A', 'YYYY-MM-DD HH:mm:ss.ssssss') }}
                    </div>
                  </div>
                </div>
                <div class="col center-title ml-4">
                  {{ getFullLocationWithCountry(this.booking.LocationID) }}
                </div>
              </div>
            </div>
            <div class="col-3 center-title p-0">
              <div class="name">{{ booking.Salutation }} {{ decodeURIComponent(booking.Case.ClaimantFullName) }}</div>
              <div>
                <p>D.O.B. {{ formatDate(booking.Case.DateofBirth, 'DD/MM/YYYY') }}</p>
                <!-- <p>case Commenced: {{formatDate(booking.commencementDate, 'DD/MM/YYYY')}}</p> -->
                <p>Type: {{ booking.ClaimType.claimTypeName }}</p>
              </div>
            </div>
            <div class="col p-0">
              <div class="row m-0">
                <div class="col-2 p-0">
                  <div class="rounded-image medium-rounded-image m-t-0 m-t-b is-icon"
                       @click="tapReadMore(specialist.id)">
                    <div v-if="specialist.profileThumbnail != ''" class="profile-image-content"><img
                        :src="specialist.profileThumbnail"/></div>
                    <div v-else class="profile-image-content notice-background"><s
                        class="text-initials">{{ getInitials(specialist) }}</s></div>
                  </div>
                </div>
                <div class="col center-title">
                  <div>
                    <div class="name is-icon" @click="tapReadMore(specialist.id)">
                      {{ specialist.fullName }}
                    </div>
                    <div class="">
                      {{ getSpecialistInfo(specialist.practiceLocationId, specialist.locations) }}
                    </div>
                    <div class="is-icon">
                      <img v-if="booking.requiresTravel" class="icon-20 mr-2"
                           src="@/assets/images/travel_black_circle_icon.svg"/>
                      <img v-if="booking.videoLinkAvailable == 2" class="icon-20"
                           src="@/assets/images/video_black_icon.svg" data-toggle="tooltip" data-placement="right"
                           title="Appointment by Video Link"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="box">
          <div class="box-heading col-space-between">
            <div>Booking details</div>
            <div class="d-flex align-items-center">
              <div v-if="booking.OriginalBookingID" class="mr-5">
                <router-link :to="{ name: 'edit-booking', query: { id: booking.OriginalBookingID } }">
                  <v-btn dark>{{ booking.OriginalBookingID }}</v-btn>
                </router-link>
              </div>
              <div v-if="booking.Status.StatusID < 5" class="mr-5">
                <span class="el-dropdown-link">
                  <img class="cursor-pointer" @click="generateFile" src="@/assets/images/calendar_black_icon.svg"
                       title="Add to Calendar"/>
                </span>
              </div>
              <v-btn v-if="!booking.originaleBookingId && showSupplementaryButton" class="mr-3" dark
                     @click="tapSupplementaryService">Supplementary Service Request
              </v-btn>
            </div>

          </div>
          <div class="box-body">
            <div class="box-row disabled-element" v-if="showOriginalClientContact">
              <div class="box-col box-col-left left-label">Original Client Contact</div>
              <div class="box-col box-col-right align-items-center d-flex">
                {{ originalClientContactDisplay }} ({{booking.OriginalClientContactID}})
              </div>
            </div>
            <div class="box-row" v-if="user.type === 2">
              <div class="box-col box-col-left left-label required">Client Contact</div>
              <div class="box-col box-col-right align-items-center d-flex">
                <div class="d-flex align-items-center w-100">
                  <el-select :disabled="booking.Status.StatusID !== 3 && booking.Status.StatusID !== 4" placeholder="Select Contact" class="w-50"
                             v-model="booking.ClientContactID" filterable>
                    <el-option v-for="item in contacts" :value="item.id" :key="item.id" :label="item.name">
                      {{ item.name }}
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="box-row disabled-element">
              <div class="box-col box-col-left ">Service Type</div>
              <div class="box-col box-col-right">
                <el-select class="w-50" clearable :disabled="true" @change="onChangeBookingType($event)"
                           v-model="booking.BookingTypeID">
                  <el-option v-for="(bookingType, index) in bookingTypes" :key="index" :value="bookingType.id"
                             :label="bookingType.name">{{
                      bookingType.name
                    }}
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="box-row disabled-element" v-if="booking.AvailabilityID && showDelivery">
              <div class="box-col box-col-left left-label required">Delivery Method</div>
              <div class="box-col box-col-right box-center">
                <el-select :disabled="true" v-model="booking.DeliveryMethodID" class=" w-75">
                  <el-option :value="2" label="Virtual"
                             title="This service will be delivered by videolink only."></el-option>
                  <el-option :value="1" label="In-Person"
                             title="This service will be delivered face to face with the Medical Expert"></el-option>
                </el-select>
                <div v-if="hasError && !validateDeliveryMethods" class="text-danger pl-2">Please select delivery
                  method
                </div>
              </div>
            </div>
            <div
                v-if="booking.DeliveryMethodID === 2 && booking.ShowVideoLinkUrl && booking.BookingType.BookingTypeID === 7"
                class="box-row">
              <div class="box-col box-col-left">Video Link URL</div>
              <div class="box-col box-col-right">
                <a v-if="booking.VideoLinkURL != ''" :href="booking.VideoLinkURL" target="_blank"
                   class="text-decoration">Join Video Link</a>
              </div>
            </div>
            <div class="box-row disabled-element" v-if="booking.BookingTypeID === 19">
              <div class="box-col box-col-left left-label required">Number of services</div>
              <div class="box-col box-col-right">
                <el-checkbox disabled v-model="showMAS" @change="onChangeNum('MAS', $event)"
                             class="default-checkbox tick">MAS
                </el-checkbox>
                <el-input-number disabled v-show="showMAS" :controls="false" style="width: 50px" v-model="booking.MAS"
                                 controls-position="right" :min="0" step-strictly :max="10"></el-input-number>
                <el-checkbox disabled v-model="showPIC" @change="onChangeNum('PIC', $event)"
                             class="default-checkbox tick">PIC
                </el-checkbox>
                <el-input-number disabled v-show="showPIC" :controls="false" style="width: 50px" v-model="booking.PIC"
                                 controls-position="right" :min="0" step-strictly :max="10"></el-input-number>
                <el-checkbox disabled v-model="showSHORT" @change="onChangeNum('ShortReport', $event)"
                             class="default-checkbox tick">Short Report
                </el-checkbox>
                <el-input-number disabled v-show="showSHORT" :controls="false" style="width: 50px"
                                 v-model="booking.ShortReport" controls-position="right" step-strictly :min="0"
                                 :max="10"></el-input-number>
                <div v-if="hasError && !validateNumOfServices" class="text-danger pl-2">Please select at least one
                  option and input the number
                </div>
              </div>
            </div>
            <div class="box-row" :class="booking.Status.StatusID >= 5 ? 'disabled-element': ''">
              <div class="box-col box-col-left">Booking Status</div>
              <div class="box-col box-col-right">
                <el-select class="w-50" @change="checkBookingAvailability($event)" :disabled="!editBookingStatus"
                           v-model="booking.Status.StatusID">
                  <el-option v-for="(status, index) in bookingStatus" :key="index" :value="status.id"
                             :label="status.name">{{ status.name }}
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="box-row" v-if="booking.BookingTypeID === 8"
                 :class="booking.Status.StatusID >= 5 ? 'disabled-element': ''">
              <div class="box-col box-col-left left-label">Future Date this Supp</div>
              <div class="box-col box-col-right box-col-center">
                <el-input class="w-50" :disabled="true" :value="booking.SuppFutureDate"/>
              </div>
            </div>
            <div v-if="booking.DeliveryMethodID === 2 && !isTPD" class="box-row disabled-element">
              <div class="box-col box-col-left left-label">Examinee Location for VideoLink</div>
              <div class="box-col box-col-right">
                <input type="text" disabled :class="hasError && examineeLocationError ? 'is-invalid' : ''" class="px-3" maxlength="255" v-model="booking.ClaimantLocation"
                       placeholder="Examinee Location for VideoLink"/>
                <div v-if="hasError && examineeLocationError" class="text-danger pl-2">{{ examineeLocationError }}</div>
              </div>
            </div>
            <div v-if="booking.DeliveryMethodID === 2 && !isTPD" class="box-row"
                 :class="booking.Status.StatusID >= 5 ? 'disabled-element': ''">
              <div class="box-col box-col-left left-label required">Examinee State During Booking</div>
              <div class="box-col box-col-right">
                <el-cascader
                    popper-class="search-no-scroll-panel"
                    :disabled="booking.Status.StatusID === 6"
                    clearable
                    v-model="bookingExamineeStatus"
                    @change="changeState"
                    :options="states"
                    placeholder="Please select"></el-cascader>
                <span v-if="timeZoneValue" class="ml-2">{{ timeZoneValue }}</span>
                <span class="pl-4 left-label">Booking Time in Examinee State</span>
                <span type="text"
                      class="w-35 ml-4">{{
                    formatDate(booking.ClaimantBookingDateTime, "DD/MM/YYYY hh:mm A", "YYYY-MM-DD HH:mm:ss.ssss")
                  }}</span>
                <div v-if="hasError && !validateState" class="text-danger pl-2">State is required.</div>
              </div>
            </div>
            <!-- <div class="box-row">
              <div  class="box-col box-col-left">Private</div>
              <div class="box-col box-col-right">
                <toggle-button @change="onChartToggleChange(0)" :color="{checked: '#56C568', unchecked: '#525252'}" :width="40" :sync="true" :value="booking.private"/>
              </div>
            </div> -->
            <div v-if="!isTPD" class="box-row" :class="booking.Status.StatusID >= 5 ? 'disabled-element': ''">
              <div class="box-col box-col-left" :class="!disableEditing ? 'disabled-element' : ''">Examinee Attendance
              </div>
              <div class="box-col box-col-right">
                <select :disabled="booking.Status.StatusID >= 5" class="textbox" v-model="booking.ClaimantConfirmed"
                        @change="toggleAttendance()">
                  <option hidden value="0">Please choose</option>
                  <option value="1">Confirmed</option>
                  <option value="2">Not confirmed</option>
                </select>
              </div>
            </div>
            <div class="box-row" :class="booking.Status.StatusID >= 5 ? 'disabled-element': ''">
              <div class="box-col box-col-left left-label">Specialist</div>
              <div class="box-col box-col-right d-flex justify-content-start align-items-center">
                <span class="px-3 w-25 mr-2">{{
                    booking.Specialist.FirstName + ' ' + booking.Specialist.Surname
                  }}</span>
                <el-tooltip effect="dark" :content="specialist.qualificationList" placement="bottom">
                    <span class="w-25"
                          style="white-space: nowrap; display: block; overflow: hidden;text-overflow: ellipsis; flex: 1">{{
                        specialist.qualificationList
                      }}</span>
                </el-tooltip>
                <!--                <router-link v-if="booking.Status.StatusID < 5" style="margin: unset" class="mr-8 ml-2"-->
                <!--                             :to="{ name: 'availability-bookings', query: { id: booking.specialistId, date: bookingDate } }"-->
                <!--                ><img src="@/assets/images/calendar_black_icon.svg"-->
                <!--                /></router-link>-->
              </div>
            </div>
            <div class="box-row" :class="booking.Status.StatusID >= 5 ? 'disabled-element': ''">
              <div class="box-col box-col-left">Reference Number</div>
              <div class="box-col box-col-right">
                <input :disabled="booking.Status.StatusID >= 5" class="textbox" type="text"
                       v-model="booking.ClientReference"
                       placeholder="Reference Number"/>
                <div v-if="hasError && clientReferenceError" class="text-danger">{{ clientReferenceError }}</div>
              </div>
            </div>
            <!--            <div class="box-row">-->
            <!--              <div class="box-col box-col-left">On behalf of</div>-->
            <!--              <div class="box-col box-col-right">-->
            <!--                <input @keyup="onChangeBehalfOf" class="textbox" maxlength="255" type="text" v-model="booking.onBehalfOf" placeholder="On behalf of" />-->
            <!--                <div v-if="hasError && !validOnBehalfOf" class="text-danger">Please do not start with '=' or  '-'  or  '+' or  '@' or  '%' and do not contains '&#45;&#45;' or '||' or '@@' </div>-->
            <!--              </div>-->
            <!--            </div>-->
            <div class="box-row" :class="booking.Status.StatusID >= 5 ? 'disabled-element': ''">
              <div class="box-col box-col-left">Date of Accident/Event</div>
              <div class="box-col box-col-right box-col-center">
                <div class="w-75">
                  <div class="right-float-element" style="line-height: 40px;">
                    <toggle-button :disabled="true" @change="changeOverTime()" class="togglePeriodOfTime"
                                   :color="{checked: '#56C568', unchecked: '#525252'}" :width="40" :sync="true"
                                   :value="!!booking.OverPeriodofTime"/>
                    Over a period of time
                  </div>
                  <datepicker
                      v-if="!booking.OverPeriodofTime"
                      format="dd/MM/yyyy"
                      :typeable="true"
                      class="w-50 accient-date"
                      placeholder="dd/mm/yyyy"
                      :disabled="true"
                      v-model="booking.AccidentDate"
                      @selected="selectAccientDate"
                      @input="changeAccientDate"></datepicker>
                </div>
              </div>
            </div>
            <!--            <div class="box-row" :class="booking.Status.StatusID >= 5 ? 'disabled-element': ''">-->
            <!--              <div class="box-col box-col-left">Commencement Date</div>-->
            <!--              <div class="box-col box-col-right box-col-center">-->
            <!--                <datepicker-->
            <!--                    class="w-50"-->
            <!--                    :disabled="true"-->
            <!--                    format="dd/MM/yyyy"-->
            <!--                    :typeable="true"-->
            <!--                    placeholder="dd/mm/yyyy"-->
            <!--                    v-model="booking.Case.CommencementDate"-->
            <!--                ></datepicker>-->
            <!--              </div>-->
            <!--            </div>-->
            <div class="box-row" :class="booking.Status.StatusID >= 5 ? 'disabled-element': ''">
              <div class="box-col box-col-left">Affected Body Areas</div>
              <div class="box-col box-col-right box-col-center pl-3">
                <vue-tags-input
                    v-model="bodyAreaTag"
                    :tags="bodyAreaTags"
                    :disabled="booking.Status.StatusID >= 5"
                    placeholder="Please choose"
                    @before-deleting-tag="deleteBodyArea"
                    @focus="openDigram"/>
              </div>
              <div v-if="booking.Status.StatusID < 5" @click="openBodyDiagram" class="center-item">
                <img src="@/assets/images/choose.svg" alt="" class="right-element align-self-center is-icon pr-3"/>
              </div>
              <AddBodyDiagramModal style="top: 0px" ref="addBodyDiagramModal"/>
            </div>
            <div class="box-row" :class="booking.Status.StatusID >= 5 ? 'disabled-element': ''">
              <div class="box-col box-col-left">Other Body Areas</div>
              <div class="box-col box-col-right box-col-center">
                <vue-tags-input :disabled="booking.Status.StatusID >= 5"
                                v-model="otherBodyAreaTag"
                                :tags="otherBodyAreaTags"
                                placeholder="Add Other Body Areas"
                                @tags-changed="updateOtherBodyArea"/>
                <div v-if="hasError && otherBodyAreasError" class="text-danger">{{ otherBodyAreasError }}</div>
              </div>
              <div class="box-col box-col-right w-auto">
              </div>
            </div>
            <div class="box-row" :class="booking.Status.StatusID >= 5 ? 'disabled-element': ''">
              <div class="box-col box-col-left">Conditions</div>
              <div class="box-col box-col-right box-col-center">
                <el-select placeholder="Add Conditions" class="w-100" :disabled="booking.Status.StatusID>= 6"
                           v-model="booking.PersonConditions" multiple clearable filterable>
                  <el-option v-for="item in personConditions" :value="item.value" :label="item.text"
                             :key="item.value"></el-option>
                </el-select>
              </div>
            </div>
            <div class="box-row" :class="booking.Status.StatusID >= 5 ? 'disabled-element': ''">
              <div class="box-col box-col-left">Report to</div>
              <div class="box-col box-col-right">
                <el-select @change="selectedSendTo" placeholder="Select a Client"
                           :disabled="booking.Status.StatusID  >= 5" class="w-100" v-model="booking.ReportTo" filterable
                           clearable>
                  <el-option v-for="contact in originalClientContacts" :key="contact.value" :value="contact.value"
                             :label="contact.name">{{ contact.name }}
                  </el-option>
                </el-select>
              </div>
            </div>
            <div v-if="showSendReportToOther" class="box-row"
                 :class="booking.Status.StatusID >= 5 ? 'disabled-element': ''">
              <div class="box-col box-col-left left-label">Send report Email</div>
              <div class="box-col box-col-right">
                <input :disabled="booking.Status.StatusID >= 5" :class="hasError && sendEmailError ? 'is-invalid' : ''" class="textbox" maxlength="100" type="text"
                       placeholder="Send report to this email address" v-model="reportToText"/>
                <div v-if="hasError && sendEmailError" class="text-danger">{{ sendEmailError }}</div>
              </div>
            </div>
            <div class="box-row" :class="booking.Status.StatusID >= 5 ? 'disabled-element': ''">
              <div class="box-col box-col-left">Bill to</div>
              <div class="box-col box-col-right">
                <el-select @change="selectedBillTo" placeholder="Select a Client"
                           :disabled="booking.Status.StatusID  >= 5" class="w-100" v-model="booking.BillTo" filterable
                           clearable>
                  <el-option v-for="contact in originalClientContacts" :key="contact.value" :value="contact.value"
                             :label="contact.name">{{ contact.name }}
                  </el-option>
                </el-select>
              </div>
            </div>
            <div v-if="showBillToEmail" class="box-row" :class="booking.Status.StatusID >= 5 ? 'disabled-element': ''">
              <div class="box-col box-col-left left-label">Bill to Email</div>
              <div class="box-col box-col-right">
                <input :disabled="booking.Status.StatusID  >= 5" :class="hasError && billEmailError ? 'is-invalid' : ''" class="textbox" type="text"
                       placeholder="Bill to this email address" v-model="billToText"/>
                <div v-if="hasError && billEmailError" class="text-danger">{{ billEmailError }}</div>
              </div>
            </div>
            <div v-if="!isTPD" class="box-row" :class="booking.Status.StatusID >= 5 ? 'disabled-element': ''">
              <div class="box-col box-col-left left-label">
                Paperwork Status
              </div>
              <div class="box-col box-col-right">
                <span>{{ isDate(booking.PaperworkProcessed) ? 'Paperwork Processed' : 'Awaiting Paperwork' }}</span>
              </div>
            </div>
            <div v-if="!isTPD" class="box-row" :class="booking.Status.StatusID >= 5 ? 'disabled-element': ''">
              <div class="box-col box-col-left">Interpreter Required?</div>
              <div class="box-col box-col-right d-flex align-items-center">
                <toggle-button :disabled="booking.Status.StatusID >= 5" @change="onChartToggleChange(1)"
                               :color="{checked: '#56C568', unchecked: '#525252'}" :width="40" :sync="true"
                               :value="booking.InterpreterRequired"/>
                <el-checkbox :disabled="booking.Status.StatusID >= 5" @change="changeFilter"
                             v-if="booking.InterpreterRequired" class="ms-3" v-model="booking.OrganizeRequired"
                             size="large">Red Health to organize
                </el-checkbox>
              </div>
            </div>
            <div class="box-row" :class="booking.Status.StatusID >= 5 ? 'disabled-element': ''"
                 v-if="booking.InterpreterRequired && !booking.OrganizeRequired ">
              <div class="box-col box-col-left">Interpreter Details</div>
              <div class="box-col box-col-right align-items-center">
                <div @click="openInterpreterDetail" :readonly="true" type="text" class=""
                     v-html="getInterpreterDetail()" placeholder="Click to add interpreter details if required"/>
                <div v-if="hasError && !validateInterpreter" class="text-danger">Interpreter detail is required.</div>
              </div>
            </div>
            <div class="box-row" :class="booking.Status.StatusID >= 5 ? 'disabled-element': ''">
              <div class="box-col box-col-left left-label">Require Pre-payment</div>
              <div class="box-col box-col-right px-3">
                <input :disabled="booking.Status.StatusID >= 5" type="checkbox" style="margin-left:20px;"
                       v-model="booking.PrepaymentRequired"/>
              </div>
            </div>
          </div>
        </div>

        <div class="box">
          <div class="box-heading tab">
            <div class="tab-heading px-5  notes-heading tab-selected" @click="openNotes">Notes</div>
            <div class="tab-heading px-5 files-heading" @click="openFiles">Files</div>
            <div class="col-space-between is-icon right-float-element">
              <v-btn class="add-icon mr-3" dark @click="openAddNoteModal"
                     v-if="showAddNote && booking.Status.StatusID !== 7 && booking.Status.StatusID !== 6">Add New
              </v-btn>
              <v-btn class="add-icon mr-3" dark @click="openFilesBox"
                     v-if="!showAddNote && ((booking.Status.StatusID !== 7 && booking.Status.StatusID !== 6 && !isTPD) || (isTPD && booking.TPDAssistOnHold))">
                Add New
              </v-btn>
              <AddNoteModal ref="addNoteModal" :bookingProps="booking"/>
            </div>
          </div>
          <div class="box-body notes-content hidden-element">
            <div class="box-row" v-for="(item, index) in bookingNoteAndActions">
              <div class="box-col box-col-left" style="width: 12%">{{ decodeURIComponent(item.userName) }}</div>
              <div class="box-col box-col-left" style="width: 13%">
                {{ formatDate(item.dateTime, 'DD/MM/YYYY hh:mm A', "YYYY-MM-DD HH:mm:ss.ssssss") }}
              </div>
              <div v-if="item.type == 'note'" @click="editNote(index)" style="width: width: 75%"
                   class="box-col box-col-right box-col-long col-center-content text-break">
                {{ decodeURIComponent(item.note) }}
              </div>
              <div v-else class="box-col box-col-right box-col-long col-center-content" style="width: 75%">
                <span class="text-bold">Requested Action:</span> {{ item.note }}
              </div>
              <div v-if="item.type == 'note' && item.note.length > 0 && booking.Status.StatusID !== 6"
                   class="col col is-icon center-title" style="max-width: 10%;" @click="deleteNote(item.id, index)"><img
                  class="right-align" :class="item.userId != user.id ? 'disabled-element' : ''"
                  src="@/assets/images/delete_icon.svg"/></div>
              <div v-if="item.type == 'action' && item.userId == user.id && booking.Status.StatusID !== 6"
                   class="col col is-icon center-title" style="max-width: 10%;" @click="editAction(item.id, index)"><img
                  class="right-align" src="@/assets/images/edit_icon.svg"/></div>
            </div>
          </div>
          <div class="box-body files-content hidden-element">
            <div>
              <div>
                <table class="table">
                  <thead>
                  <tr>
                    <th style="width:20%" class="long-text">
                      File Type
                      <img v-if="listParam.SortFlag === 1" class="sort-icon"
                           :src="require('@/assets/images/down_arrow_icon.svg')" @click="sortParam(2)"/>
                      <img v-else-if="listParam.SortFlag === 2" class="sort-icon"
                           :src="require('@/assets/images/up_arrow_icon.svg')" @click="sortParam(0)"/>
                      <img v-else class="sort-icon" :src="require('@/assets/images/default_arrow.svg')"
                           @click="sortParam(1)"/>
                    </th>
                    <th style="width:30%" class="long-text">
                      File Name
                      <img v-if="listParam.SortFlag === 3" class="sort-icon"
                           :src="require('@/assets/images/down_arrow_icon.svg')" @click="sortParam(4)"/>
                      <img v-else-if="listParam.SortFlag === 4" class="sort-icon"
                           :src="require('@/assets/images/up_arrow_icon.svg')" @click="sortParam(0)"/>
                      <img v-else class="sort-icon" :src="require('@/assets/images/default_arrow.svg')"
                           @click="sortParam(3)"/>
                    </th>
                    <th style="width:15%" class="long-text">
                      Uploaded By
                      <img v-if="listParam.SortFlag === 5" class="sort-icon"
                           :src="require('@/assets/images/down_arrow_icon.svg')" @click="sortParam(6)"/>
                      <img v-else-if="listParam.SortFlag === 6" class="sort-icon"
                           :src="require('@/assets/images/up_arrow_icon.svg')" @click="sortParam(0)"/>
                      <img v-else class="sort-icon" :src="require('@/assets/images/default_arrow.svg')"
                           @click="sortParam(5)"/>
                    </th>
                    <th style="width:20%" class="long-text">
                      Date Uploaded
                      <img v-if="listParam.SortFlag === 7" class="sort-icon"
                           :src="require('@/assets/images/down_arrow_icon.svg')" @click="sortParam(8)"/>
                      <img v-else-if="listParam.SortFlag === 8" class="sort-icon"
                           :src="require('@/assets/images/up_arrow_icon.svg')" @click="sortParam(0)"/>
                      <img v-else class="sort-icon" :src="require('@/assets/images/default_arrow.svg')"
                           @click="sortParam(7)"/>
                    </th>
                    <th style="width:10%" class="long-text">
                      Status
                      <img v-if="listParam.SortFlag === 9" class="sort-icon"
                           :src="require('@/assets/images/down_arrow_icon.svg')" @click="sortParam(10)"/>
                      <img v-else-if="listParam.SortFlag === 10" class="sort-icon"
                           :src="require('@/assets/images/up_arrow_icon.svg')" @click="sortParam(0)"/>
                      <img v-else class="sort-icon" :src="require('@/assets/images/default_arrow.svg')"
                           @click="sortParam(9)"/>
                    </th>
                    <th style="width:5%" class="icon-col">
                      <div class="icon-group">&nbsp;</div>
                    </th>
                  </tr>
                  </thead>
                </table>
              </div>
              <div class="content-scroll-y" style="height:auto;max-height:460px;">
                <table class="table remove-min-height">
                  <tbody :key="fileKey">
                  <tr v-for="(file, index) in booking.bookingFiles" :key="index">
                    <td style="width:15%" class="long-text">
                      <el-select :disabled="booking.Status.StatusID === 6 || (!booking.TPDAssistOnHold && isTPD)"
                                 v-model="file.FileTypeID"
                                 v-if="file.UploadedBy === user.id" class="w-100"
                                 @change="updateFileType(file.BookingFileID, index)">
                        <el-option v-for="fileType in fileTypes" :value="fileType.FileTypeID" :key="fileType.FileTypeID"
                                   :label="fileType.FileTypeName" :disabled="fileType.disable">{{
                            fileType.FileTypeName
                          }}
                        </el-option>
                      </el-select>
                      <span style="padding-left: 10px;" v-else>{{ file.FileType.FileTypeName }}</span>
                    </td>
                    <td style="width:30%" title="download" @click="getFileUrl(file)" class="long-text cursor-pointer">
                      <el-tooltip effect="dark" :content="file.FileName">
                        <span> {{ file.FileName }}</span>
                      </el-tooltip>
                    </td>
                    <td style="width:15%" class="long-text">{{ decodeURIComponent(file.UploadedUser.UserName) }}</td>
                    <td style="width:20%" class="long-text">
                      {{ formatDate(file.DateUploaded, 'MM/DD/YYYY HH:mm:ss', 'YYYY-MM-DD HH:mm:ss.ssss') }}
                    </td>
                    <td style="width:10%" class="long-text">
                      <span
                          style="padding-left: 10px;">{{
                          file.FileStatus == 2 ? 'Complete' : getFileStatusNameById(file.FileStatus)
                        }}</span>
                    </td>
                    <td style="width:5%; vertical-align: middle;" class="long-text is-icon">
                      <div class="icon-group d-flex justify-content-center"><img
                          v-if="booking.Status.StatusID !== 7 && booking.Status.StatusID !== 6 && file.FileStatus < 2 && file.UploadedBy === user.id && (file.FileTypeName ==='Brief' || file.FileTypeName ==='Other' || file.FileTypeName ==='Letter of Instruction')"
                          @click="deleteFile(file.BookingFileID, index, file.UploadedBy)"
                          src="@/assets/images/delete_icon.svg"/></div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div
                v-if="booking.Status.StatusID !== 7 && booking.Status.StatusID !== 6 && (!isTPD || (isTPD && booking.TPDAssistOnHold))"
                class="file-upload-area border-gray-300 mt-5" @dragover="dragover"
                @dragleave="dragleave" @drop="drop">
              <input
                  type="file"
                  multiple
                  name="fields[assetsFieldHandle][]"
                  id="assetsFieldHandle"
                  class="w-px h-px opacity-0 overflow-hidden absolute"
                  @change="onChange"
                  ref="file"
                  accept=""/>
              <label for="assetsFieldHandle"
                     class="block cursor-pointer d-flex flex-column align-items-center justify-content-center">
                <div>Drop files in this area or <span style="text-decoration:underline"
                                                      class="is-icon">click here</span> to upload files.
                </div>
                <div>Files over 200MB in file size may cause errors. If you need to upload files of this size, please
                  contact us on 1300 100 733
                </div>
              </label>
              <FileTypeModal ref="fileTypeModal"/>
            </div>
          </div>
        </div>
        <div class="alert alert-success hidden-element">
          <a class="close" title="close">×</a>
          <b>Success:</b> {{ successMessage }}
        </div>
        <div class="alert alert-danger hidden-element">
          <a class="close" title="close">×</a>
          <b>Error:</b> {{ errorMessage }}
        </div>
        <div class="alert-warning alert confirmation hidden-element">
          <div class="icon-group center-element">
            <v-btn class="alert-button" @click="tapButtonConfirmation(true)">Ok</v-btn>
          </div>
          <b>Warning:</b> {{ errorMessage }}
        </div>
        <div class="box-row item-right button-action" v-if="booking.Status.StatusID < 6">
          <div style="padding-right:20px"
               :class="(!disableEditing || this.booking.BookingTypeID !== 2) ? 'disabled-element' : ''">
            <v-btn dark @click="tapCancel">Reschedule / Cancel</v-btn>
          </div>
          <div style="padding-right:20px" v-if="booking.Status.StatusID == 1">
            <v-btn dark @click="tapDelete">Delete</v-btn>
          </div>
          <div style="padding-right:20px">
            <v-btn dark @click="tapRequestAction" v-if="booking.Status.StatusID != 7">Request Action</v-btn>
          </div>
          <div :class="!hasChange ? 'disabled-element' : ''">
            <v-btn :class="!hasChange ? 'disabled-element' : ''" dark @click="tapUpdateBooking"
                   v-if="booking.Status.StatusID != 7">Update
            </v-btn>
          </div>
          <CancelBookingModal ref="cancelBookingModal"/>
          <RequestActionModal ref="requestActionModal"/>
        </div>
      </div>
    </div>
    <el-dialog title="Select TimeZone" :visible.sync="showTimeZone">
      <div>
        <el-select filterable v-model="timeZoneValue">
          <el-option v-for="item in timeZones" :key="item" :value="item" :label="item"></el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
    <v-btn dark class="white-button" @click="cleanData">Cancel</v-btn>
    <el-button type="primary" @click="showTimeZone = false;">OK</el-button>
  </span>
    </el-dialog>
    <InterpreterDetailDialog ref="interpreterModal" :user="user" @clickSave="handleSaveInterpreterDetail"/>
    <Chat/>
  </div>
</template>

<script>
import utilities from '@/assets/js/utilities'
import Navigation from '@/components/Navigation'
import CaseMenu from '@/components/CaseMenu'
import Header from '@/components/Header'
import Chat from '@/components/Chat'
import CancelBookingModal from '@/components/CancelBookingModal'
import RequestActionModal from '@/components/RequestActionModal'
import AddNoteModal from '@/components/AddNoteModal'
import ProfileReadMoreModal from '@/components/ProfileReadMoreModal'
import AddBodyDiagramModal from '@/components/AddBodyDiagramModal'
import FileTypeModal from '@/components/FileTypeModal'
import InterpreterDetailDialog from "@/components/dialog/InterpreterDetailDialog.vue";
import {ics} from "calendar-link";


export default {
  name: 'EditBooking',
  components: {
    Navigation,
    CaseMenu,
    Header,
    Chat,
    AddNoteModal,
    CancelBookingModal,
    RequestActionModal,
    ProfileReadMoreModal,
    AddBodyDiagramModal,
    FileTypeModal,
    InterpreterDetailDialog,
  },
  data() {
    return {
      showSHORT: false,
      showMAS: false,
      showPIC: false,
      contacts: [],
      bookingExamineeStatus: [],
      oldExamineeStatus: [],
      timeZones: [],
      timeZoneValue: null,
      showTimeZone: false,
      listParam: {
        SortFlag: 0,
      },
      curSpecialty: '',
      bookingTypes: [],
      claimTypes: [],
      specialist: [],
      clientContacts: [],
      client: [],
      bookingActions: [],
      filelist: [],
      bookingLog: [],
      locations: [],
      bookingNoteAndActions: [],
      validOnBehalfOf: true,
      bodyAreaTag: "",
      otherBodyAreaTag: "",
      personConditionTag: "",
      bodyAreas: [],
      bodyAreaTags: [],
      otherBodyAreaTags: [],
      originalOtherBodyAreaTags: [],
      deletedBodyTags: [],
      personConditions: [],
      personConditionTags: [],
      originalPersonConditionTags: [],
      deletedConditionTags: [],
      addedBodyArea: [],
      addedConditions: [],
      showDelivery: false,
      states: [],
      billToText: '',
      reportToText: '',
      subTitle: '',
      toggleInterpreter: '',
      successMessage: '',
      errorMessage: '',
      hasError: false,
      isEdit: true,
      showContent: false,
      editBookingStatus: false,
      disableEditing: true,
      loaded: false,
      fileKey: 0,
      showError: false,
      showAddNote: true,
      callBookingAction: false,
      togglePeriodOfTime: false,
      isUpdated: false,
      bookingDate: moment().format('DD/MM/YYYY'),
      isChangedAttendance: false,
      originalStatus: '',
      fileStatus: utilities.getFileStatus(),
      fileTypeId: 0,
      fileTypes: [],
      showRedRescheduleBtn: false,
      pagination: utilities.initPagination(),
      booking: utilities.initBooking(),
      oldBooking: utilities.initBooking(),  // booking from API
      originalBooking: utilities.initBooking(), // original booking
      bookingStatus: utilities.getBookingStatuses(),
      case: utilities.initCase(),
      showBillToEmail: false,
      showSendReportToOther: false,
      listContact: [],
      originalClientContacts: [],
      isSelected: false,
    }
  },
  watch: {
    booking: {
      handler(value) {
        if (this.loaded) {
          this.$store.dispatch("setNewObject", value)
          let originalObject = this.$store.getters["getOriginalObject"] || {}
          originalObject.billingNotes = value.billingNotes
          originalObject.bookingNotes = value.bookingNotes
          originalObject.bookingFiles = value.bookingFiles
          this.$store.dispatch("setOriginalObject", originalObject)
        }
      },
      deep: true,
    },
  },
  computed: {
    showOriginalClientContact() {
      return !!(this.booking.OriginalClientContactID && this.booking.ClientContactID != this.booking.OriginalClientContactID)
    },
    originalClientContactDisplay() {
      const contact = this.booking.OriginalClientContact
      if (!contact) return ''
      if (typeof contact === 'string') return contact
      return contact.ClientContactFullName + '-' + contact.EmailAddress
    },
    user() {
      return this.$store.getters['user/getUser'];
    },
    isTPD() {
      return this.booking.BookingTypeID === 19
    },
    validateNumOfServices() {
      if (this.booking.BookingTypeID === 19 && !this.showSHORT && !this.showMAS && !this.showPIC) {
        return false
      }
      if ((this.showSHORT && !this.booking.ShortReport) || (this.showMAS && !this.booking.MAS) || (this.showPIC && !this.booking.PIC)) {
        return false
      }
      return true
    },
    clientReferenceError() {
      return utilities.getAdminBookingClientReferenceError(this.booking.ClientReference)
    },
    validateDeliveryMethods() {
      if (utilities.bookingTypeWithDeliveryMethods(this.booking.BookingTypeID)) {
        return this.booking.DeliveryMethodID
      }
      return true
    },
    showSupplementaryButton() {
      return moment().unix() > moment(this.booking.bookingDateTime).unix()
    },
    validateInterpreter() {
      if (this.booking.InterpreterRequired && !this.booking.OrganizeRequired && !this.booking.InterpreterName) {
        return false
      }
      return true
    },
    validateBillEmail() {
      return !this.billEmailError
    },
    billEmailError() {
      if (!this.showBillToEmail) {
        return ''
      }
      return utilities.getClientContactEmailError(this.billToText, 'Bill to email', false)
    },

    validateSendEmail() {
      return !this.sendEmailError
    },
    sendEmailError() {
      if (!this.showSendReportToOther) {
        return ''
      }
      return utilities.getClientContactEmailError(this.reportToText, 'Send report email', false)
    },

    validateState() {
      if (this.booking.DeliveryMethodID === 2 && !this.isTPD && (!this.bookingExamineeStatus || this.bookingExamineeStatus.length === 0 || !this.bookingExamineeStatus[0])) {
        return false
      }
      return true
    },
    examineeLocationError() {
      if (this.booking.DeliveryMethodID !== 2 || this.isTPD) {
        return ''
      }
      return utilities.getExamineeLocationForVideoLinkError(this.booking.ClaimantLocation)
    },
    otherBodyAreasError() {
      return utilities.getAdminBookingOtherBodyAreasError(this.otherBodyAreaTags)
    },

    hasChange() {
      var result = false
      // Format Accident Date after selected from the calendar
      if (typeof this.booking.accidentDate != 'string' && moment(this.booking.accidentDate, "YYYY-MM-DD").isValid()) {
        this.booking.accidentDate = moment(this.booking.accidentDate, "YYYY-MM-DD").format("YYYY-MM-DD")
      }
      if (this.bookingExamineeStatus.join(',') !== this.oldExamineeStatus.join(',')) {
        result = true
        return result
      }

      if (_.isEqual(this.originalBooking, this.booking)
          && _.isEqual(this.originalOtherBodyAreaTags, this.otherBodyAreaTags)
          && _.isEqual(this.originalPersonConditionTags, this.personConditionTags)) {
        result = false
      } else {
        result = true
      }
      return result
    },

    filteredBodyAreaItems() {
      return this.bodyAreas.filter(i => {
        return i.text.toLowerCase().indexOf(this.bodyAreaTag.toLowerCase()) !== -1;
      })
    },

    filteredPersonConditionsItems() {
      return this.personConditions.filter(i => {
        return i.text.toLowerCase().indexOf(this.personConditionTag.toLowerCase()) !== -1;
      })
    },
  },
  methods: {
    onChangeNum(name, value) {
      console.log(this.booking)
      if (value) {
        this.$set(this.booking, name, 1)
      } else {
        this.$set(this.booking, name, 0)
      }
      this.$forceUpdate()
      console.log(this.booking)
    },
    handleSaveInterpreterDetail(obj) {
      this.booking = {...this.booking, ...obj}
    },
    openInterpreterDetail() {
      if (this.booking.Status.StatusID === 6) return
      this.$set(this.$refs.interpreterModal.curItem, 'InterpreterName', _.cloneDeep(this.booking.InterpreterName || ''))
      this.$set(this.$refs.interpreterModal.curItem, 'InterpreterCompanyName', _.cloneDeep(this.booking.InterpreterCompanyName || ''))
      this.$set(this.$refs.interpreterModal.curItem, 'InterpreterContactNumber', _.cloneDeep(this.booking.InterpreterContactNumber || ''))
      this.$set(this.$refs.interpreterModal.curItem, 'InterpreterContactEmail', _.cloneDeep(this.booking.InterpreterContactEmail || ''))
      this.$set(this.$refs.interpreterModal.curItem, 'InterpreterCost', _.cloneDeep(this.booking.InterpreterCost))
      this.$refs.interpreterModal.visible = true
      this.$forceUpdate()
    },
    getInterpreterDetail() {
      let str = ''
      if (this.booking.InterpreterName) {
        str += '<b>N: </b>' + this.booking.InterpreterName + '&nbsp'
      }
      if (this.booking.InterpreterCompanyName) {
        str += '<b>C: </b>' + this.booking.InterpreterCompanyName + '&nbsp'
      }
      if (this.booking.InterpreterContactNumber) {
        str += '<b>P: </b>' + this.booking.InterpreterContactNumber + '&nbsp'
      }
      if (this.booking.InterpreterContactEmail) {
        str += '<b>E: </b>' + this.booking.InterpreterContactEmail + '&nbsp'
      }
      if (str === '') {
        str += '<span style="color: #D5D5D5">Click to Add Detail</span'
      }
      return str
    },
    cleanData() {
      this.showTimeZone = false;
      this.timeZoneValue = null;
      this.booking.ClaimantCountryDuringBooking = null
      this.booking.ClaimantStateDuringBooking = null
      this.bookingExamineeStatus = []
      this.oldExamineeStatus = this.bookingExamineeStatus.concat()
    },
    async changeState(e) {
      if (e && e.length > 0) {
        this.booking.ClaimantCountryDuringBooking = e[0]
        this.booking.ClaimantStateDuringBooking = e[1]
        if (e[0] === e[1] && e[1] === "International") {
          await this.$store.dispatch("loading/setLoadComponent", true);
          this.timeZones = await utilities.getTimeZone()
          this.showTimeZone = true
          await this.$store.dispatch("loading/setLoadComponent", false);
        } else {
          this.timeZoneValue = null
        }
        this.$forceUpdate()
      } else {
        this.booking.ClaimantCountryDuringBooking = null
        this.booking.ClaimantStateDuringBooking = null
      }
    },
    changeFilter(v) {
      if (v) {
        this.booking.interpreterDetails = ''
      }
    },
    sortParam(param = 7) {
      this.listParam.SortFlag = param
      switch (param) {
        case 1:
          this.booking.bookingFiles.sort((a, b) => {
            return (b.FileTypeName >= a.FileTypeName) ? 1 : -1
          })
          break;
        case 2:
          this.booking.bookingFiles.sort((a, b) => {
            return (a.FileTypeName >= b.FileTypeName) ? 1 : -1
          })
          break;
        case 3:
          this.booking.bookingFiles.sort((a, b) => {
            return (b.FileName >= a.FileName) ? 1 : -1
          })
          break;
        case 4:
          this.booking.bookingFiles.sort((a, b) => {
            return (a.FileName >= b.FileName) ? 1 : -1
          })
          break;
        case 5:
          this.booking.bookingFiles.sort((a, b) => {
            return (b.UserName >= a.UserName) ? 1 : -1
          })
          break;
        case 6:
          this.booking.bookingFiles.sort((a, b) => {
            return (a.UserName >= b.UserName) ? 1 : -1
          })
          break;
        case 7:
          this.booking.bookingFiles.sort((a, b) => {
            if (moment(a.DateUploaded).isAfter(moment(b.DateUploaded))) {
              return -1
            }
            return 1
          })
          break;
        case 8:
          this.booking.bookingFiles.sort((a, b) => {
            if (moment(a.DateUploaded).isBefore(moment(b.DateUploaded))) {
              return -1
            }
            return 1
          })
          break;
        case 9:
          this.booking.bookingFiles.sort((a, b) => {
            return b.FileStatus - a.FileStatus
          })
          break;
        case 10:
          this.booking.bookingFiles.sort((a, b) => {
            return a.FileStatus - b.FileStatus
          })
          break;
      }
    },
    getFileUrl(file) {
      const params = {
        fn: file.FileName,
        id: this.booking.BookingID,
        VersionId: file.VersionId,
        filetype: "bf",
      }
      utilities.getDownloadFileUrlNew(params).then(res => {
        let a = document.createElement('a');
        let fileName = file.fileName
        a.target = '_blank'
        a.download = fileName;
        a.href = res
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(res);
        document.body.removeChild(a);
      })
    },
    toggleAttendance() {
      this.isChangedAttendance = true
    },

    getInitials(specialist) {
      return utilities.getInitials(specialist.firstName, specialist.lastName)
    },

    checkBookingObjectisUpdated() {
      if (_.isEqual(this.originalBooking, this.booking)) {
        this.isUpdated = false
      } else {
        this.isUpdated = true
      }
    },

    getOriginalBooking() {
      if (!this.isUpdated) {
        this.originalBooking = _.cloneDeep(this.booking)
        this.originalOtherBodyAreaTags = _.cloneDeep(this.otherBodyAreaTags)
        this.originalPersonConditionTags = _.cloneDeep(this.personConditionTags)
      }
    },

    tapSupplementaryService() {
      this.$router.push({name: 'supplementary-service-request', query: {id: this.booking.BookingID}}).catch((err) => {
      })
    },

    changeOverTime() {
      this.booking.overPeriodofTime = !this.booking.overPeriodofTime
      if (this.booking.overPeriodofTime) {
        this.booking.accidentDate = ''
      }
      this.isValidAccidentDate = this.validateAccidentDate()
    },

    validateAccidentDate() {
      if ($(".accient-date input").val().length > 0) {
        if ((this.booking.accidentDate == '' || !moment($(".accient-date input").val(), "DD/MM/YYYY").isValid()) && !this.overTime) {
          return false
        }
      }
      return true
    },

    updateConditions(newTags) {
      if (this.$refs.conditions.newTag.length == 0) newTags.pop()
      this.personConditionTags = newTags
      this.booking.personConditions = this.personConditionTags
    },

    updateOtherBodyArea(newTags) {
      this.otherBodyAreaTags = newTags
      this.booking.BodyAreaOther = this.otherBodyAreaTags
    },

    selectAccientDate() {
      this.booking.overPeriodofTime = false
    },

    changeAccientDate() {
      setTimeout(() => {
        this.isValidAccidentDate = this.validateAccidentDate()
      }, 200)
    },

    deleteBodyArea(obj) {
      if (this.booking.Status.StatusID >= 5) return
      this.openDigram()
      // this.deletedBodyTags.push(obj.tag)
      // if (this.deletedBodyTags.length > 0) {
      //   this.deletedBodyTags.forEach((item, i) => {
      //     var bodyArea = this.bodyAreas.filter((y) => y.text == item.text)[0]
      //     if (bodyArea) {
      //       bodyArea = {
      //         BodyAreaID: bodyArea.value,
      //         BookingBodyAreaID: bodyArea.value
      //       }
      //       bodyAreaObjects.push(bodyArea)
      //     }
      //   });
      // }
      // var params = {
      //   BookingId: this.booking.BookingID,
      //   BodyAreaObject: bodyAreaObjects
      // }
      //
      // await utilities.putBookingBodyAreaPersonCondition(params)
      // this.bodyAreaTags.splice(obj.index, 1);
    },

    deletePersonCondition(obj) {
      this.deletedConditionTags.push(obj.tag)
      this.personConditionTags.splice(obj.index, 1);
      this.booking.personConditions = this.personConditionTags
    },

    openDigram() {
      if (this.booking.Status.StatusID >= 5) return
      this.openBodyDiagram()
    },

    openBodyDiagram() {
      this.$refs.addBodyDiagramModal.handleModal()
      this.$refs.addBodyDiagramModal.filteredBodyAreas = this.bodyAreas
      this.$refs.addBodyDiagramModal.bodyAreas = _.cloneDeep(this.bodyAreaTags)
      this.$refs.addBodyDiagramModal.handleClick()
    },

    async setBodyArea(newBodyTags) {
      this.$store.dispatch("loading/setLoadComponent", true)
      await this.callUpdateBodyAreaAPI(newBodyTags)
      this.$store.dispatch("loading/setLoadComponent", false)
    },

    deleteBodyAreaItems(items) {
      items.map((x) => {
        this.deletedBodyTags.push(x.tag)
      })
    },

    async callUpdateBodyAreaAPI(newBodyTags) {
      var bodyAreaObjects = []
      var bodyArea = {}

      // Pass deleted body Area object
      if (this.deletedBodyTags.length > 0) {
        this.deletedBodyTags.map((x) => {
          var temp = this.booking.bodyAreas.find((y) => y.bodyArea == x.text)
          if (temp) {
            bodyArea = {
              BodyAreaID: temp.bodyAreaId,
              BookingBodyAreaID: temp.bookingBodyAreaId
            }
            bodyAreaObjects.push(bodyArea)
          }
        })
      }

      // Pass new body Area object
      if (newBodyTags.length > 0) {
        this.bodyAreaTags = newBodyTags
        this.booking.BodyAreas = newBodyTags.map(item => {
          return {
            BodyAreaID: item.value,
            BodyArea: item.text
          }
        })
      }

      if (bodyAreaObjects.length > 0) {
        var params = {
          BookingId: this.booking.BookingID,
          BodyAreaObject: bodyAreaObjects,
          UserID: this.user.id,
          Username: this.user.name,
        }
        var result = await utilities.putBookingBodyAreaPersonCondition(params)
        if (result) {
          this.bodyAreaTags = _.cloneDeep(newBodyTags)
          // Get body Areas after updating
          var booking = await utilities.getBookingById(this.booking.BookingID)
          this.setclaimantConfirmed()
          if (booking) this.booking.bodyAreas = _.cloneDeep(booking.bodyAreas)
          utilities.showSuccessMessage("Booking details updated.")
        }
        this.deletedBodyTags = []
        this.getOriginalBooking()
      }
    },

    filterReportTo(text) {
      if (text.length > 0) {
        this.listClients = this.originalClientContacts.filter((item) => item.name.toLowerCase().indexOf(text.toLowerCase()) > -1);
      }
    },

    selectedBillTo(item) {
      if (item === 'Other') {
        this.billToText = ''
        this.showBillToEmail = true
      } else {
        this.showBillToEmail = false
      }
      this.$forceUpdate()
    },

    selectedSendTo(item) {
      if (item === 'Other') {
        this.reportToText = ""
        this.showSendReportToOther = true
      } else {
        this.showSendReportToOther = false
      }
      this.$forceUpdate()
    },
    getFileStatusNameById(id) {
      if (id == 2) {
        return 'Complete'
      } else if (id == 3) {
        return 'For Review'
      }
      if (id != 3) {
        return this.fileStatus.find((x) => x.id == id).name
      }
      return ''
    },

    tapButtonConfirmation(states) {
      utilities.hideAlert('.confirmation')
    },

    async checkBookingAvailability(event) {
      this.showError = false
      var date = moment(this.booking.bookingDateTime, "YYYY-MM-DD HH:mm:ss.ssssss").format('YYYY-MM-DD')
      var todayDate = moment().format('YYYY-MM-DD')
      if (moment(date, "YYYY-MM-DD").isBefore(todayDate)) {
        this.errorMessage = 'The selected date and time is no longer available.  Please contact Red Health.'
        this.showError = true
      }
    },

    async finalizeFile(bookingFileId, index) {
      var file = this.booking.bookingFiles[index]
      this.$store.dispatch('loading/setLoadComponent', true)
      var params = {
        BookingFileID: bookingFileId,
        FileStatus: file.fileStatus,
        UserID: this.user.id,
        Username: this.user.name,
        BookingID: this.booking.BookingID,
        FileStatusName: this.fileStatus.find((x) => x.id == file.fileStatus).name,
        FileName: file.fileName,
        BookingDateTime: (this.booking.bookingDateTime !== "" && this.booking.bookingDateTime.indexOf('0000-00-00') < 0) ? window.moment(this.booking.bookingDateTime, "YYYY-MM-DD HH:mm:ss.ssssss").format('YYYY-MM-DD HH:mm:ss') : null,
        SpecialistName: this.booking.specialistFullName,
        CaseOwnerName: this.getCaseOwnerName(),
        ClientName: this.booking.clientName + ' - ' + this.booking.branchName,
        BookingTypeName: this.booking.BookingType.BookingTypeName,
        LocationName: this.getLocationName(this.booking.locationId),
        CurrentDateTime: moment().format('YYYY-MM-DD HH:mm:ss'),
      }
      await utilities.putBookingFileDetails(params)
      this.getOriginalBooking()
      this.$store.dispatch('loading/setLoadComponent', false)
    },

    async updateFileType(bookingFileId, index) {
      var file = this.booking.bookingFiles[index]
      this.$store.dispatch('loading/setLoadComponent', true)
      var params = {
        FileTypeID: file.FileTypeID,
        BookingID: this.booking.BookingID,
        FileName: file.FileName,
      }
      await utilities.putBookingFileDetails(bookingFileId, params)
      this.getOriginalBooking()
      this.$store.dispatch('loading/setLoadComponent', false)
    },

    tapReadMore(index) {
      this.$refs.profileReadMoreModal.loadData(index)
      this.$refs.profileReadMoreModal.handleModal()
    },

    getSpecialistInfo(locationId, locations) {
      var text = ""
      if (this.specialist.qualificationList) {
        text = this.specialist.qualificationList
      }

      // if (locationId) {
      //   var value = locations.find((x) => x.id == locationId).shortLocation
      //   if (value) {
      //     if (text.length == 0) {
      //       return value
      //     } else {
      //       return text + ", " + value
      //     }
      //   }
      // }
      return text
    },

    onChartToggleChange(index) {
      switch (index) {
        case 0:
          this.booking.private = !this.booking.private
          break;
        case 1:
          this.booking.InterpreterRequired = !this.booking.InterpreterRequired
          this.booking.OrganizeRequired = false
          this.callBookingAction = this.booking.InterpreterRequired
          if (!this.booking.InterpreterRequired) {
            this.booking.interpreterDetails = ""
            this.booking.InterpreterName = ''
            this.booking.InterpreterCompanyName = ''
            this.booking.InterpreterContactNumber = ''
            this.booking.InterpreterContactEmail = ''
          }
          break;
        case 2:
          this.booking.otfceRequired = !this.booking.otfceRequired
          break;
        default:
      }
    },

    formatDate(date, format = "YYYY-MM-DD", currentFormat = "YYYY-MM-DD") {
      if (date != '') {
        if (format == 'MMM, YYYY hh:mm A' && this.booking.Status.StatusID == 16) {
          format = 'MMM, YYYY'
        }
        return utilities.formatDateUTC(date, format, currentFormat)
      }
      return ''
    },

    onChangeBookingType(e) {

    },

    getFile(filePath, fileName) {
      utilities.getFile(filePath, fileName)
    },

    onChangeContact(event, status) {
    },

    async bookingCancel() {
      this.booking.Status.StatusID = 6
      this.editBookingStatus = false
      this.successMessage = 'The booking has now been cancelled.'
      utilities.showAlert(".alert-success")
      this.bookingStatus = utilities.getBookingStatuses(),
          await this.loadData()
    },

    async actionConfirmation(isNew = true) {
      if (isNew) {
        this.successMessage = "Your update has been saved."
        utilities.showAlert(".alert-success")
      }
      this.bookingActions = await utilities.getBookingActions(this.booking.BookingID)
      this.setBookingNoteAndAction()
    },

    async tapUpdateBooking() {
      if (!this.hasChange) {
        return
      }

      if (!this.validateState || !this.validateDeliveryMethods || !this.validateInterpreter || !this.validateBillEmail || !this.validateSendEmail || this.otherBodyAreasError || this.clientReferenceError || this.examineeLocationError) {
        this.hasError = true
        this.errorMessage = "Please correct the errors shown above and try again."
        utilities.showAlert(".alert-danger")
        return
      }

      if (this.showError) {
        this.showWarning()
        this.booking.Status.StatusID = this.originalStatus
        return
      }

      var otherBodyArea = ""
      this.otherBodyAreaTags.map((x) => {
        if (otherBodyArea == "") {
          otherBodyArea = x.text
        } else {
          otherBodyArea = otherBodyArea + "," + x.text
        }
      })

      var params = {
        Booking: {
          PrepaymentRequired: this.booking.PrepaymentRequired ? 1 : 0,
          MAS: this.showMAS ? this.booking.MAS : 0,
          PIC: this.showPIC ? this.booking.PIC : 0,
          ShortReport: this.showSHORT ? this.booking.ShortReport : 0,
          ClientReference: this.ClientReference,
          ClientContactID: this.booking.ClientContactID,
          BookingStatus: this.booking.Status.StatusID.toString(),
          BillTo: this.showBillToEmail ? this.billToText : this.booking.BillTo,
          ReportTo: this.showSendReportToOther ? this.reportToText : this.booking.ReportTo,
          BookingTypeID: this.booking.BookingTypeID,
          CaseID: this.booking.CaseID,
          InterpreterRequired: this.booking.InterpreterRequired,
          OrganizeRequired: this.booking.OrganizeRequired,
          CaseReference: this.booking.CaseReference,
          CallClientAfterAppointment: this.booking.CallClientAfterAppointment,
          BookingEndTime: this.booking.BookingDateTime ? window.moment(this.booking.BookingEndTime, 'HH:mm:ss').format('HH:mm:ss') : undefined,
          AvailabilityID: this.booking.AvailabilityID,
          LocationID: this.booking.LocationID,
          BodyAreaOther: otherBodyArea,
          ClaimantStateDuringBooking: this.bookingExamineeStatus && this.bookingExamineeStatus.length > 1 ? this.bookingExamineeStatus[1] : null,
          ClaimantCountryDuringBooking: this.bookingExamineeStatus && this.bookingExamineeStatus.length > 1 ? this.bookingExamineeStatus[0] : null,
          ClaimantTimeZoneDuringBooking: !this.isTPD ? this.timeZoneValue : undefined,
        },
        BodyAreas: this.booking.BodyAreas.map(item => {
          return {BodyAreaID: item.BodyAreaID}
        }),
        PersonConditions: this.booking.PersonConditions.map(item => {
          return {PersonConditionID: item}
        })
      }

      if (utilities.bookingTypeWithDeliveryMethods(this.booking.BookingTypeID)) {
        params.Booking.DeliveryMethodID = this.booking.DeliveryMethodID
      }

      if (!this.isTPD) {
        params.Booking.InterpreterName = this.booking.InterpreterName ? this.booking.InterpreterName : ""
        params.Booking.InterpreterCompanyName = this.booking.InterpreterCompanyName ? this.booking.InterpreterCompanyName : ""
        params.Booking.InterpreterContactNumber = this.booking.InterpreterContactNumber ? this.booking.InterpreterContactNumber : ""
        params.Booking.InterpreterContactEmail = this.booking.InterpreterContactEmail ? this.booking.InterpreterContactEmail : ""
        params.Booking.InterpreterCost = typeof this.booking.InterpreterCost === 'number' ? Number(this.booking.InterpreterCost) : null
        params.Booking.BookingDateTime = (this.booking.BookingDateTime && this.booking.BookingDateTime.indexOf('0000-00-00') < 0) ? window.moment(this.booking.BookingDateTime, "YYYY-MM-DD HH:mm:ss.ssssss").format('YYYY-MM-DD HH:mm:ss') : null
      }

      if (this.isChangedAttendance) {
        params.Booking.ClaimantConfirmed = this.booking.ClaimantConfirmed == "1" ? moment().format('YYYY-MM-DD HH:mm:ss') : ''
      }

      this.isUpdated = false
      var callback = async (response) => {
        this.isChangedAttendance = false
        this.$store.dispatch("setOriginalObject", null)
        this.$store.dispatch("setNewObject", null)

        this.successMessage = "Your update has been saved."
        utilities.showAlert(".alert-success")
        await this.loadData()
        this.originalBooking = _.cloneDeep(this.booking)
        this.checkBookingObjectisUpdated()
        this.getOriginalBooking()
      }
      this.$store.dispatch("loading/setLoadComponent", true)
      let id = this.$route.query.id != undefined ? this.$route.query.id : ''
      const curBooking = await utilities.getBookingById(id)
      if (curBooking.UpdatedTime !== this.booking.UpdatedTime) {
        this.$alert('The booking information has been updated by another user. The page will be refreshed, and you can make your change again.', 'Warning', {
          confirmButtonText: 'OK',
          callback: () => {
            window.location.reload()
          }
        })
        this.$store.dispatch("loading/setLoadComponent", false)
        return
      }

      let obj = {...params}
      for (let key in obj.Booking) {
        if ((obj.Booking[key] === null || obj.Booking[key] === '' || obj.Booking[key] === undefined) && key.indexOf('Interpreter') < 0 && key.indexOf('SurrogateAssessor') < 0) {
          delete obj.Booking[key];
        }
      }
      if (this.booking.OrganizeRequired) {
        obj.Booking.InterpreterName = ''
        obj.Booking.InterpreterCompanyName = ''
        obj.Booking.InterpreterContactNumber = ''
        obj.Booking.InterpreterContactEmail = ''
      }

      await utilities.putBooking(this.booking.BookingID, params, callback)

      if (this.callBookingAction != this.oldBooking.interpreterRequired && this.callBookingAction) {
        var parem = {
          BookingID: this.booking.BookingID,
          RequestedBy: this.user.id,
          BookingActionRequestStatus: '1',
          RequestedAction: "Interpreter Required",
        }
        var callback = (response) => {
        }
        utilities.postBookingAction(parem, callback)
      }
      this.oldBooking = _.cloneDeep(this.booking)
      this.$store.dispatch("loading/setLoadComponent", false)
    },

    getLocationState(id) {
      if (id) {
        return this.locations.find((x) => x.id == id).state
      }
    },

    editNote(index) {
      if (this.booking.Status.StatusID === 6) return
      var item = this.bookingNoteAndActions[index]
      var note = this.booking.bookingNotes.find(x => x.id === item.id)
      if (item.userId === this.user.id) {
        this.$refs.addNoteModal.isEditClient = true
        this.$refs.addNoteModal.internalOnly = 0
        this.$refs.addNoteModal.editCurrentNote(note, false)
        this.$refs.addNoteModal.handleModal()
      }
    },

    editAction(id, index) {
      var item = this.bookingNoteAndActions[index]
      var action = this.bookingActions.find(x => x.id == item.id)
      this.$refs.requestActionModal.editAction(action)
      this.$refs.requestActionModal.handleModal()
    },

    async deleteFile(fileId, index, uploadedBy) {
      var file = this.booking.bookingFiles[index]
      this.$confirm({
        content: 'Are you sure you want to delete this file?',
        onConfirm: async () => {
          this.$store.dispatch('loading/setLoadComponent', true)
          var params = {
            userId: this.user.id,
            userName: this.user.name,
            id: fileId,
          }
          var params2 = {
            BookingID: this.booking.BookingID,
            FileName: file.FileName,
            BookingDateTime: (this.booking.BookingDateTime !== "" && this.booking.BookingDateTime.indexOf('0000-00-00') < 0) ? window.moment(this.booking.BookingDateTime, "YYYY-MM-DD HH:mm:ss.ssssss").format('YYYY-MM-DD HH:mm:ss') : null,
            SpecialistName: this.booking.specialistFullName,
            CaseOwnerName: this.getCaseOwnerName(),
            ClientName: this.booking.clientName + ' - ' + this.booking.branchName,
            BookingTypeName: this.booking.BookingType.BookingTypeName,
            LocationName: this.getLocationName(this.booking.locationId),
            CurrentDateTime: window.moment().format('YYYY-MM-DD HH:mm:ss'),
            UserID: this.user.id,
            Username: this.user.name,
            IsDeleted: 1
          }
          var result = await utilities.deleteBookingFileById(params, params2)
          if (result) {
            this.booking.bookingFiles.splice(index, 1)
            this.getOriginalBooking()
          }
          this.$store.dispatch('loading/setLoadComponent', false)
        }
      })
    },

    openNotes() {
      this.showAddNote = true
      $('.notes-content').show()
      $('.tab-selected').removeClass('tab-selected')
      $('.notes-heading').addClass('tab-selected')
      $('.files-content').hide()
    },

    openFiles() {
      this.showAddNote = false
      $('.notes-content').hide()
      $('.tab-selected').removeClass('tab-selected')
      $('.files-heading').addClass('tab-selected')
      $('.files-content').show()
    },

    openAddNoteModal(e) {
      this.checkBookingObjectisUpdated()
      this.$refs.addNoteModal.addNewNote(0)
      this.$refs.addNoteModal.handleModal()
    },

    openFilesBox() {
      $('#assetsFieldHandle').trigger('click')
    },

    // addFileIntoBooking(file) {
    //   var newFile = {
    //     bookingFileId: 66,
    //     fileName: ,
    //     filePath: ,
    //     fileStatus: ,
    //     fileTypeId ,
    //     fileTypeName,
    //     uploadedBy:
    //   }
    //   this.booking.bookingFiles.push(newFile)
    // }

    openFileTypeModal() {
      this.$refs.fileTypeModal.reset()
      this.$refs.fileTypeModal.fileTypes = this.fileTypes
      this.$refs.fileTypeModal.handleModal()
    },

    clearFile() {
      $("#assetsFieldHandle").val(null)
    },

    onChange() {
      this.openFileTypeModal()
    },

    async uploadFile() {
      if (this.fileTypeId > 0) {
        this.$store.dispatch('loading/setLoadComponent', true)
        this.checkBookingObjectisUpdated()
        this.filelist = [...this.$refs.file.files]
        var allFileNames = ''
        if (this.filelist.length > 0) {
          await Promise.all(this.filelist.map(async (x) => {
            if (this.booking.BookingID != '') {
              try {
                var fileName = x.name
                const mimeType = await utilities.getFileMimeType(x, x.type || 'application/octet-stream')
                if (allFileNames.length == 0) {
                  allFileNames = fileName
                } else {
                  allFileNames = allFileNames + ', ' + fileName
                }
                const result = await utilities.postPreSign({
                  ft: mimeType,
                  fn: fileName,
                  id: this.booking.BookingID,
                  FileStatus: 0,
                  FileTypeID: this.fileTypeId,
                })
                let postData = new FormData()
                for (let key in result.fields) {
                  postData.append(key, result.fields[key]);
                }
                postData.append('file', x)
                const r = await utilities.postImage(result.url, postData)
                if (r) {
                  await utilities.postFileRecord({
                        BookingID: this.booking.BookingID,
                        FileName: x.name,
                        FileStatus: 0,
                        FileTypeID: this.fileTypeId,
                        MimeType: mimeType
                      }
                  )
                }
                if (this.filelist.length > 0) {
                  this.booking.bookingFiles = await utilities.getBookingFileNew({
                    BookingID: this.booking.BookingID,
                    pageNum: 1,
                    pageSize: 999
                  })
                  this.sortParam(this.listParam.SortFlag)
                  this.showClientsFiles()
                  this.checkBookingObjectisUpdated()
                  this.getOriginalBooking()
                  this.fileKey += 1
                }
              } catch (error) {
                utilities.showErrorMessage(error.response.data?.message || error.response.data || error)
              }
            }
          }))
        }

        this.$store.dispatch('loading/setLoadComponent', false)
      }
    },

    remove(i) {
      this.filelist.splice(i, 1)
    },
    dragover(event) {
      event.preventDefault()
      // Add some visual fluff to show the user can drop its files
      // if (!event.currentTarget.classList.contains('bg-green-300')) {
      //   event.currentTarget.classList.remove('bg-gray-100')
      //   event.currentTarget.classList.add('bg-green-300')
      // }
      event.currentTarget.classList.add('dark-border-hover')
    },
    dragleave(event) {
      // Clean up
      // event.currentTarget.classList.add('bg-gray-100')
      // event.currentTarget.classList.remove('bg-green-300')
      event.currentTarget.classList.remove('dark-border-hover')
    },
    drop(event) {
      event.preventDefault()
      this.$refs.file.files = event.dataTransfer.files
      this.onChange() // Trigger the onChange event manually
      // Clean up
      event.currentTarget.classList.add('bg-gray-100')
      event.currentTarget.classList.remove('bg-green-300')
      event.currentTarget.classList.remove('dark-border-hover')
    },

    tapCancel() {
      if (!this.disableEditing || this.booking.BookingTypeID !== 2) {
        return
      }
      var timeLeft = moment().diff(moment(this.booking.BookingDateTime, "YYYY-MM-DD HH:mm:ss"), 'hours');
      if (timeLeft < 48) {
        var showCancelMsg = false
        this.bookingLog.map(x => {
          if (x.LogDetails.includes("(8)") || x.LogDetails.includes("(9)")) {
            showCancelMsg = false
          } else {
            showCancelMsg = true
          }
        })
      }

      if (this.booking.BookingTypeID === 17) {
        this.$notify({
          dangerouslyUseHTMLString: true,
          message: '<div class="alert-warning">' +
              '            <b>Warning:</b> To cancel or reschedule this assessment, please call us on 1300 100 733' +
              '          </div>',
        });
        return
      }

      if (showCancelMsg) {
        this.$refs.cancelBookingModal.showRescheduleMsg()
      }
      this.$refs.cancelBookingModal.handleModal()
    },

    async tapDelete() {
      this.$confirm({
        content: 'Are you sure you want to delete this Booking?',
        onConfirm: async () => {
          this.$store.dispatch('loading/setLoadComponent', true)
          var params = {
            userID: this.user.id,
            userName: this.user.name,
            bookingId: this.booking.BookingID,
            caseId: this.booking.CaseID
          }
          var result = await utilities.deleteBooking(params)
          if (result) {
            window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')

          }
          this.$store.dispatch('loading/setLoadComponent', false)
        }
      })
    },

    tapReschedule() {
      this.$router.replace('admin-search-specialist?rescheduleId=' + this.booking.BookingID)
    },

    tapRequestAction() {
      this.$refs.requestActionModal.handleModal()
    },

    async deleteNote(noteId, index) {
      var note = this.bookingNoteAndActions[index]
      if (note.userId != this.user.id) {
        return
      }
      this.$confirm({
        content: 'Are you sure you want to delete this note?',
        onConfirm: async () => {
          this.$store.dispatch('loading/setLoadComponent', true)
          var params = {
            UserID: this.user.id,
            Username: this.user.name,
            id: noteId,
            IsMainEdit: this.hasChange ? 1 : 0,
          }
          if (params.IsMainEdit === 0) {
            params.BookingDateTime = (this.booking.BookingDateTime !== "" && this.booking.BookingDateTime.indexOf('0000-00-00') < 0) ? window.moment(this.booking.BookingDateTime, "YYYY-MM-DD HH:mm:ss.ssssss").format('YYYY-MM-DD HH:mm:ss') : null,
                params.SpecialistName = this.booking.specialistFullName
            params.CaseOwnerName = this.getCaseOwnerName()
            params.ClientName = this.booking.clientName + ' - ' + this.booking.branchName
            params.BookingTypeName = this.booking.BookingType.BookingTypeName
            params.LocationName = this.getLocationName(this.booking.locationId)
            params.IsAdmin = true
            params.BookingID = this.booking.BookingID
            params.NoteDateTime = moment().format('YYYY-MM-DD HH:mm:ss')
          }
          var result = await utilities.deleteBookingNoteById(params)
          if (result) {
            note.deleted = true
            var deleteNote = this.booking.bookingNotes.find((x) => x.id == note.id)
            deleteNote.deleted = true
            this.bookingNoteAndActions.splice(index, 1)
            this.getOriginalBooking()
          }
          this.$store.dispatch('loading/setLoadComponent', false)
        }
      })
    },

    getLocationName(id) {
      if (id) {
        var value = this.locations.find((x) => x.id == id)
        if (value) {
          return value.shortLocation
        }
      }
    },

    getFullLocation(id) {
      if (id && this.locations.length > 0) {
        return this.locations.find((x) => x.id == id).fullLocation.replace(', Australia', "")
      }
    },

    getFullLocationWithCountry(id) {
      if (id && this.locations.length > 0) {
        return this.locations.find((x) => x.id == id).fullLocation
      }
    },

    async setBookingNoteAndAction(params) {
      if (params && this.bookingNoteAndActions && this.bookingNoteAndActions.length > 0) {
        const booking = this.bookingNoteAndActions.find(x => x.id === params.BookingNoteID)
        booking.dateTime = params?.NoteDateTime
        booking.note = params?.Note
        return
      }
      var bookingNoteAndActions = []
      for (var i = 0; i < this.booking.bookingNotes.length; i++) {
        var item = this.booking.bookingNotes[i]
        if (!item.deleted) {
          var noteObject = {
            id: item.BookingNoteID,
            userName: item.UsernameLog,
            userId: item.UserID,
            dateTime: params && params?.BookingNoteID === item.id ? params?.NoteDateTime : item.NoteDateTime,
            note: item.Note,
            type: 'note',
            internalOnly: item.InternalOnly,
          }
          bookingNoteAndActions.push(noteObject)
        }
      }

      for (var i = 0; i < this.bookingActions.length; i++) {
        var item = this.bookingActions[i]
        var noteObject = {
          id: item.BookingActionRequestID,
          userName: item.RHOUserName,
          userId: item.RequestedBy,
          dateTime: item.DateRequested,
          note: item.RequestedAction,
          type: 'action'
        }
        if (noteObject.note.indexOf('additional') > -1 && noteObject.note.indexOf('hour') > -1 && noteObject.note.indexOf('Time') > -1) {

        } else {
          bookingNoteAndActions.push(noteObject)
        }
      }
      bookingNoteAndActions.sort((a, b) => {
        return moment(a.dateTime, "YYYY-MM-DD HH:mm:ss.ssssss").isBefore(moment(b.dateTime, "YYYY-MM-DD HH:mm:ss.ssssss")) ? 1 : -1
      })
      this.bookingNoteAndActions = bookingNoteAndActions
    },

    getCaseOwnerName() {
      if (this.booking == undefined || this.booking.bookingId == '') {
        return ''
      }

      if (this.booking.clientContacts.length > 0) {
        return this.booking.clientContacts[0].clientContactFullName
      }
    },

    showWarning() {
      $('html, body').animate({
        scrollTo: $(".button-action").offset()
      }, 500);
      utilities.showAlert('.confirmation', false)
    },

    showClientsFiles() {
      var files = []
      this.booking.bookingFiles.map((x) => {
        if (x.FileTypeName != 'Internal Document' && x.FileTypeName != 'Other' && x.FileTypeName != 'Report' && !x.IsDeleted) {
          files.push(_.cloneDeep(x))
        } else if (x.FileTypeName == 'Other' && x.UploadedBy == this.user.id && !x.IsDeleted) {
          files.push(_.cloneDeep(x))
        } else if (x.FileTypeName == 'Other' && x.FileStatus == 1 && x.UploadedBy != this.user.id && !x.IsDeleted) {
          files.push(_.cloneDeep(x))
        } else if (x.FileTypeName == 'Report' && x.FileStatus == 2 && !x.IsDeleted) {
          if (!this.booking.prepaymentRequired) {
            files.push(_.cloneDeep(x))
          } else if (this.booking.prepaymentRequired && this.booking.paid) {
            files.push(_.cloneDeep(x))
          }
        }
      })
      this.booking.bookingFiles = _.cloneDeep(files)
    },

    isDate(date) {
      return moment(date, "YYYY-MM-DD").isValid()
    },

    setclaimantConfirmed() {
      if (this.isDate(this.booking.ClaimantConfirmed)) {
        this.booking.ClaimantConfirmed = '1'
      } else {
        this.booking.ClaimantConfirmed = '2'
      }
    },

    generateFile(service) {
      const summary = this.booking.BookingType.BookingTypeName
      const location = decodeURIComponent(this.booking.Location.LocationName);
      const event = {
        title: summary,
        start: this.formatDate(this.booking.BookingDateTime, 'YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm:ss.ssssss'),
        end: this.bookingDate + ' ' + this.booking.BookingEndTime,
        location: location,
        description: 'Added from ReadHealth'
      }

      window.open(this.getCalendarURL(event), "calendar");
    },
    getCalendarURL(event) {
      let url = "";
      url = ics(event);
      console.log(event)
      return url;
    },

    generateUID() {
      return `${new Date().getTime()}${Math.floor(Math.random() * 1000)}`;
    },

    async loadData() {
      await this.$store.dispatch("loading/setLoadComponent", true)
      const id = this.$route.query.id !== undefined ? this.$route.query.id : null

      if (id) {
        this.booking = await utilities.getBookingById(id)
        this.booking.ClientContactID = this.booking.ClientContactID ? this.booking.ClientContactID : null
        this.booking.SuppFutureDate = this.booking.SuppFutureDate ? moment.utc(this.booking.SuppFutureDate).format('DD/MM/YYYY HH:mm') : null
        this.bookingExamineeStatus = [this.booking.ClaimantCountryDuringBooking, this.booking.ClaimantStateDuringBooking]
        this.oldExamineeStatus = this.bookingExamineeStatus.concat()
        this.timeZoneValue = this.booking.ClaimantTimeZoneDuringBooking

        this.showMAS = this.booking.MAS > 0
        this.showPIC = this.booking.PIC > 0
        this.showSHORT = this.booking.ShortReport > 0

        this.setclaimantConfirmed()
        this.bookingDate = this.booking.BookingDateTime ? window.moment(this.booking.BookingDateTime, "YYYY-MM-DD HH:mm:ss.ssssss").format('YYYY-MM-DD') : ""
        if (this.booking == undefined) {
          this.showContent = false
          return
        } else {
          this.showContent = true
        }
        this.showDelivery = utilities.bookingTypeWithDeliveryMethods(this.booking.BookingTypeID)
        if (this.booking.BookingDateTime && window.moment(this.booking.BookingDateTime, "YYYY-MM-DD HH:mm:ss.ssssss").isSameOrAfter(window.moment())) {
          this.subTitle = "Reschedule, Request Action, Cancel or Request a Supplementary Service."
        } else {
          this.subTitle = "Request Action or Request a Supplementary Service."
        }

        this.oldBooking = _.cloneDeep(this.booking)

        if (this.booking.BodyAreas && this.booking.BodyAreas.length > 0) {
          this.bodyAreaTags = utilities.getAutoCompleteBodyAreaTags(this.booking.BodyAreas)
        }

        if (this.booking.BodyAreaOther && this.booking.BodyAreaOther.length > 0) {
          var items = this.booking.BodyAreaOther.split(',');
          this.otherBodyAreaTags = utilities.getAutoCompleteOtherBodyAreaTags(items)
        }

        if (this.booking.PersonConditions.length > 0) {
          this.booking.PersonConditions = this.booking.PersonConditions.map(item => item.PersonConditionID)
        }


        this.specialist = utilities.formatSpecialist([this.booking.Specialist])[0]

        if (this.booking.Status.StatusID === 1 || this.booking.BookingStatus === 2) {
          var editBookingStatus = []
          this.editBookingStatus = true
          this.bookingStatus.map((x) => {
            if (x.id === 1 || x.id === 2 || x.id === 3) {
              editBookingStatus.push(x)
            }
          })
          this.bookingStatus = editBookingStatus
        } else if (this.booking.Status.StatusID === 5 || this.booking.Status.StatusID === 9 || this.booking.Status.StatusID === 10 || this.booking.Status.StatusID === 11 || this.booking.Status.StatusID === 12 || this.booking.Status.StatusID === 13 || this.booking.Status.StatusID === 14 ||
            this.booking.Status.StatusID === 15) {
          this.disableEditing = false
        }

        if ((this.booking.BookingStatus === '6' && window.moment(this.booking.BookingDateTime, "YYYY-MM-DD HH:mm:ss.ssssss").diff(window.moment(this.booking.CancellationDate, "YYYY-MM-DD HH:mm:ss.ssssss"), 'day') <= 2) && window.moment().diff(window.moment(this.booking.CancellationDate, "YYYY-MM-DD HH:mm:ss.ssssss"), 'day') < 14 && this.booking.Case.Client.RedRescheduleEnabled) {
          this.showRedRescheduleBtn = true
        }
        if (this.booking.BookingStatus === '7' && this.booking.Case.Client.RedRescheduleEnabled && window.moment().diff(window.moment(this.booking.UpdatedTime, "YYYY-MM-DD HH:mm:ss.ssssss"), 'day') < 14) {
          this.showRedRescheduleBtn = true
        }

        const apiArr = [utilities.getBookingLogsById(id), utilities.getBookingActions(id), utilities.getBookingFileNew({
          BookingID: id,
          pageNum: 1,
          pageSize: 999
        })]
        Promise.all(apiArr).then(r => {
          this.bookingLog = r[0]
          this.bookingActions = r[1]
          this.booking.bookingFiles = r[2]
          this.showClientsFiles()
        })
      }

      const apisArr = [utilities.getBookingTypes(), utilities.getClaimTypes(), utilities.getLocations(), utilities.choiceGetContact(this.user.clientId), utilities.getBodyArea(), utilities.getPersonConditions(), utilities.getFileTypes(), utilities.getCaseByCaseId(this.booking.CaseID), utilities.getBookingNotes({
        BookingID: id,
        pageNum: 1,
        pageSize: 999
      }), utilities.getStateCodes()]
      const r = await Promise.all(apisArr)
      let allBookingTypes = r[0]
      this.claimTypes = r[1]
      this.locations = r[2]
      this.clientContacts = r[3]
      this.contacts = _.cloneDeep(utilities.getClientsDropdownAutoCompleteTag(this.clientContacts, false))
      let bodyAreas = r[4]
      this.bodyAreas = utilities.getAutoCompleteBodyAreaTags(bodyAreas)

      let personConditions = r[5]
      this.personConditions = utilities.getAutoCompleteTagsUpperCase(personConditions)

      let types = r[6]
      this.case = r[7]
      this.booking.bookingNotes = r[8]
      this.states = r[9]
      //set Bill to and Report To data
      this.originalClientContacts = _.cloneDeep(utilities.getClientsDropdownAutoCompleteTag(this.clientContacts))
      this.listContact = _.cloneDeep(this.originalClientContacts)
      this.bookingTypes = allBookingTypes
      // Check if Bill To is undefined
      if (this.booking.BillTo == undefined) {
        this.booking.BillTo = this.oldBooking.billTo
      }
      // Check if Report To is undefined
      if (this.booking.ReportTo == undefined) {
        this.booking.ReportTo = this.oldBooking.reportTo
      }
      //set send report to data
      if (this.booking.ReportTo) {
        var sendReportTo = this.listContact.find((x) => x.value.toLowerCase().includes(this.booking.ReportTo.toLowerCase()))
        console.log(sendReportTo)
        if (!sendReportTo) {
          sendReportTo = {
            id: -1,
            name: "Other",
            value: 'Other'
          }
          this.showSendReportToOther = true
          this.reportToText = this.booking.ReportTo
          this.booking.ReportTo = 'Other'
        } else {
          this.reportToText = sendReportTo.value
        }
      }

      //setBill to email
      if (this.booking.BillTo != undefined && this.booking.BillTo != '') {
        var billTo = this.listContact.find((x) => x.value.toLowerCase().includes(this.booking.BillTo.toLowerCase()))
        if (billTo == undefined && this.booking.BillTo) {
          billTo = {
            id: -1,
            name: "Other",
            value: 'Other'
          }
          this.showBillToEmail = true
          this.billToText = this.booking.BillTo
          this.booking.BillTo = 'Other'
        }
      }

      setTimeout(() => {
        $(".dropdown-input").attr({
          autocomplete: "off",
        });
      }, 1000)

      this.originalStatus = _.cloneDeep(this.booking.Status.StatusID)
      types.map((x) => {
        if (x.FileTypeName == 'Brief' || x.FileTypeName == 'Letter of Instruction' || x.FileTypeName == 'Other') {
          this.fileTypes.push(x)
        }
        if (x.FileTypeID === 11 || x.FileTypeID === 12) {
          if (!this.isTPD) {
            x.disable = true
          }
          this.fileTypes.push(x)
        }
      })
      console.log(this.fileTypes)
      this.openNotes()
      this.setBookingNoteAndAction()
      this.$store.dispatch("loading/setLoadComponent", false)
      this.$store.dispatch("setOriginalObject", this.booking)
      this.$store.dispatch("setNewObject", this.booking)
    },
  },

  async beforeMount() {
    await this.loadData()
    // Check if Claimant State During Booking is undefined
    if (this.booking.claimantStateDuringBooking == undefined) {
      this.booking.claimantStateDuringBooking = this.oldBooking.claimantStateDuringBooking
    }
    this.getOriginalBooking()
    this.loaded = true
    utilities.initTooltip()
    this.isSelected = false
  },

  mounted() {
    window.scrollTo({top: 0, behavior: 'smooth'})
    $('[data-toggle="tooltip"]').tooltip()

    setTimeout(() => {
      $(".report-to-selecter input").after("<div class='dropdown-input-clear'></div>")
      $(".report-to-selecter .dropdown-input-clear").click((e) => {
        this.$refs.dropdownEmailSendTo.searchFilter = ""
        this.booking.ReportTo = ""
        this.showSendReportToOther = false
      })

      $(".bill-to-selecter input").after("<div class='dropdown-input-clear'></div>")
      $(".bill-to-selecter .dropdown-input-clear").click((e) => {
        this.$refs.dropdownEmailBillTo.searchFilter = ""
        this.booking.BillTo = ""
        this.showBillToEmail = false
      })
    }, 1000)
  },
}
</script>

<style scoped>
.search-popup-longer .el-select-dropdown__wrap {
  max-height: 330px;
}

.default-checkbox.tick {
  margin-left: 20px;
  margin-right: 20px;
  height: 40px;
}

::v-deep .el-input-number .el-input__inner {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
</style>
